import React, { createContext, useContext, useEffect, useState } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) {
          authAPI.logout();
        } else {
          setUser(authAPI.getCurrentUser());
        }
      } catch {
        authAPI.logout();
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const data = await authAPI.login(username, password);
      const { accessToken, ...userData } = data;
      setUser(userData);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Anmeldung fehlgeschlagen' };
    }
  };

  const register = async (username, email, password) => {
    try {
      await authAPI.register(username, email, password);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Registrierung fehlgeschlagen' };
    }
  };

  const logout = () => {
    authAPI.logout();
    setUser(null);
  };

  const isAdmin = user?.roles?.includes('ROLE_ADMIN');

  return (
    <AuthContext.Provider value={{
      user, login, register, logout, loading, isAdmin, isAuthenticated: !!user,
    }}
    >
      {children}
    </AuthContext.Provider>
  );
};
